import React from 'react';
import Admin  from './Admin';
import Tabs from '../../Layout/Tabs';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { getFolderI } from '../../api/services';

const AdminPage: React.FC = () => {

  const { data: Tabsdata, isLoading, isError } = useQuery('alltabs', getFolderI);

  if (isLoading) {
      return <LinearProgress />;
    }
  
    if (isError) {
      return <Typography>Error loading folders. Please try again later.</Typography>;
    }


  return (
      <>  
        <Admin foldersdata={Tabsdata?.data} />
      </>
  );
};

export default AdminPage;